module.exports = __webpack_public_path__ + "img/7.d6202c27.jpg";